export default __webpack_public_path__ + "static/media/Right002.63bf0012.png";